<script>
import appConfig from '@src/app.config.json'
import Axios from '@plugin/axios'
import Layout from '@layouts/main.vue'
import PlainCard from '@components/ui/cards/plain-card.vue'
import queryString from 'query-string'

export default {
  page() {
    return {
      title: this.pageTitle,
      meta: this.pageMeta,
    }
  },
  components: {
    Layout,
    PlainCard,
  },
  filters: {
    excerpt: function(text, limit) {
      return (
        text
          .split(/\s+/)
          .slice(0, limit)
          .join(' ') + '...'
      )
    },
    plainText: function(HTML) {
      var input = HTML
      return input
        .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, '')
        .replace(/<[^>]+?>/g, '')
        .replace(/\s+/g, ' ')
        .replace(/ /g, ' ')
        .replace(/>/g, ' ')
    },
  },
  data() {
    return {
      Journal: {},
      currentUrl: window.location.origin + window.location.pathname,
      /** language switcher global */
      lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'id',
      /** FOR SEO AND META TAG PURPOSE */
      featuredImage: '',
      pageTitle: 'Loading...',
      pageMeta: [],
      notFoundState: false,
      origin: window.location.origin,
    }
  },
  async mounted() {
    const url = this.$route
    const watchLang = queryString.parse(window.location.search).lang
    if (url.query.page) {
      window.addEventListener('popstate', (e) => {
        this.$router.push({ path: `/academic-journal?page=${url.query.page}` })
      })
    }
    if (watchLang) {
      this.getJournal({ lang_relation: watchLang })
    } else {
      this.getJournal()
    }
  },
  methods: {
    getJournal: function(param = {}) {
      /** define ANY API prequisite */
      var params = {
        klaster_slug: 'academic-journals',
        record_slug: this.$route.params.slug,
        lang: this.lang,
        simple: true,
      }
      /** params need to encoded from object to url params */
      params = this.generateParams(params, param)
      /** define endpoint */
      var endpoint = `klaster-by-member-relation?${params}`

      Axios.get(endpoint).then((response) => {
        const data = response.data.data[0]
        if (response.data && data) {
          this.Journal = data
          this.openComment()
          /** FOR SEO AND META TAG PURPOSE */
          this.pageTitle = data.title

          this.pageMeta = [
            {
              name: 'description',
              content: this.$options.filters
                .plainText(data.content)
                .slice(0, 160),
            },
            // facebook
            {
              property: 'og:type',
              content: 'article',
            },
            {
              property: 'og:title',
              content: data.title,
            },
            {
              property: 'og:description',
              content: this.$options.filters
                .plainText(data.content)
                .slice(0, 160),
            },
            {
              property: 'og:image',
              content: this.featuredImage,
            },
            {
              property: 'og:url',
              content: this.currentUrl,
            },
            {
              property: 'og:site_name',
              content: appConfig.title,
            },
            // twitter
            {
              name: 'twitter:title',
              content: data.title,
            },
            {
              name: 'twitter:image',
              content: this.featuredImage,
            },
            {
              name: 'twitter:description',
              content: this.$options.filters
                .plainText(data.content)
                .slice(0, 160),
            },
            {
              name: 'twitter:site',
              content: this.currentUrl,
            },
          ]
        } else {
          this.notFoundState = true
        }
      })
    },
    /**
     * Open Comment, this should be in Mixin!
     */
    openComment: function() {
      // momento js
      const momento = document.createElement('script')
      momento.setAttribute('src', 'https://commento.lexikan.id/js/commento.js')
      document.head.appendChild(momento)
    },
    parsedBody(HTML) {
      return HTML.replace(/\n/g, '<br>')
    },
    /**
     * Download handler from backend
     */
    download: function(id) {
      // this.getFullReport()
      return appConfig.download_handler + id
    },
  },
}
</script>

<template>
  <div>
    <b-container
      v-if="notFoundState"
      style="min-height: 50vh;display:flex;align-items:center"
    >
      <b-row :class="$style.errorHandler">
        <b-col cols="12">
          <p>{{ $t('journal_no_data') }} </p>
          <a
            class="text-primary"
            pointer
            @click="$router.push({ name: 'academic-journal' })"
            >{{ $t('back_page') }}</a
          >
        </b-col>
      </b-row>
    </b-container>
    <Layout v-else-if="notFoundState === false">
      <b-container v-if="Journal.atribut" class="my-5">
        <b-row :class="$style.contentWrapper">
          <b-col cols="lg-4" :class="$style.sidebarLeft">
            <div :class="$style.holder">
              <PlainCard title="Links" heading-tag="h5" class="my-4">
                <ul :class="$style.sourceList">
                  <li
                    v-for="(source, index) in Journal.atribut.link_source.data"
                    :key="index"
                  >
                    <a :href="source.content">{{
                      index > 0 ? 'Source ' + (index + 1) : 'Source'
                    }}</a>
                  </li>
                  <li
                    v-for="(gs, index) in Journal.atribut.link_google_scholar
                      .data"
                    :key="index"
                  >
                    <a :href="gs.content" target="_blank">{{
                      index > 0
                        ? 'Google Scholar ' + (index + 1)
                        : 'Google Scholar'
                    }}</a>
                  </li>
                </ul>
              </PlainCard>
              <div
                v-for="(down, index) in Journal.atribut.link_download.data"
                :key="index"
              >
                <a
                  v-if="index < 1"
                  :href="download(down.ID)"
                  class="btn-lg btn-block my-2 d-flex align-items-center justify-content-center bg-primary text-white"
                >
                  <img
                    src="@assets/icons/Icon_Download.png"
                    alt=""
                    :style="{ filter: 'brightness(5)', marginRight: '1rem' }"
                    width="18"
                  />
                  Download
                </a>
                <small v-if="Journal.atribut.download_counts.data.length !== 0"
                  >{{ $t('Downloads') }}:
                  {{ Journal.atribut.download_counts.data[0].content }}
                </small>
              </div>
            </div>
          </b-col>
          <!-- Content -->
          <b-col cols="lg-8">
            <div :class="$style.journal">
              <div :class="$style.journalHeading">
                <h1>{{ Journal.title }}</h1>
                <span class="date" :style="{ color: 'gray' }">
                  <i>{{ Journal.created_at_format }}</i>
                </span>
              </div>
              <div v-html-safe="Journal.content" :class="$style.journalBody">
              </div>
              <div :class="$style.journalFooter">
                <h3>Information</h3>
                <div :class="$style.informationList">
                  <div
                    v-for="(atribut, index) in Journal.atribut.information.data"
                    :key="index"
                    v-html-safe="parsedBody(atribut.content)"
                    class="d-block"
                  ></div>
                </div>

                <div class="my-5">
                  Share :
                  <ShareNetwork
                    network="facebook"
                    :url="currentUrl"
                    :title="Journal.title"
                    :description="Journal.content | plainText | excerpt(25)"
                    hashtags="lexikan"
                  >
                    <img
                      src="@assets/icons/Icon_FB.png"
                      alt=""
                      :class="$style.social"
                    />
                  </ShareNetwork>
                  <ShareNetwork
                    network="twitter"
                    :url="
                      `${origin}/sharer.php?page=academic-journals/journal&slug=${Journal.slug}`
                    "
                    :title="Journal.title"
                    hashtags="lexikan"
                  >
                    <img
                      src="@assets/icons/Icon_Twitter.png"
                      alt=""
                      :class="$style.social"
                    />
                  </ShareNetwork>
                  <ShareNetwork
                    network="linkedin"
                    :title="Journal.title"
                    :url="currentUrl"
                  >
                    <img
                      src="@assets/icons/Icon_Linkedin.png"
                      alt=""
                      :class="$style.social"
                    />
                  </ShareNetwork>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <b-container>
        <!-- comments -->
        <b-row class="my-5">
          <b-col cols="lg-8">
            <h2 :style="{ color: 'gray' }" class="my-5">{{
              $t('Comments')
            }}</h2>
            <div id="commento"></div>
          </b-col>
        </b-row>
      </b-container>
    </Layout>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.sidebarLeft {
  .holder {
    position: sticky;
    top: 1.75rem;
  }
  .sourceList {
    padding-left: 0;
    margin-left: 0.5rem;
    li {
      margin: 0.75rem 0;
      font-size: 1.1rem;
      font-weight: $semi-bold;
      color: $primary;
      list-style: none;
    }
  }
}
.journal {
  .journalHeading {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-weight: $bold;
      color: $dark;
    }
  }
  .journalBody {
    margin: 2rem 0;
  }
  .journalFooter {
    h3 {
      color: gray;
    }
    .informationList {
      padding-left: 0;
      li {
        color: gray;
        list-style: none;
      }
    }
    .social {
      width: 48px;
      margin-right: 0.5rem;
      cursor: pointer;
      &:first-child {
        margin-left: 0.75rem;
      }
    }
  }
}

@media only screen and (max-width: $mobile-sm) {
  .contentWrapper {
    flex-direction: column-reverse;
  }
}
</style>
